import React, { forwardRef, Fragment, HtmlHTMLAttributes, memo, useContext } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { BreadcrumbsContext } from "../../core";
import { RefType } from "../../types";
import { BreadcrumbBase, BreadcrumbBaseProps } from "./BreadcrumbBase";

import { ReactComponent as Chevron } from "./icons/chevron-right.svg";
import { ReactComponent as Slash } from "./icons/slash-divider.svg";

import styles from "./styles.module.scss";

export type BreadcrumbsPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  ref?: RefType<HTMLDivElement>
  dividerType?: "chevron" | "slash"
  containerType?: "text" | "line" | "brand" | "gray"
}

export const Breadcrumbs = memo<BreadcrumbsPropsType>(forwardRef((
  {
    className,
    dividerType = "slash",
    containerType = "brand",
    ...props
  },
  ref,
) => {
  const breadcrumbs = useContext(BreadcrumbsContext);
  //TODO implement hidden breadcrumbs button
  return (
    <div
      ref={ref}
      aria-label="breadcrumbs"
      className={classNames(
        styles.root,
        className,
        styles[containerType],
      )}
      {...props}
    >
      {
        breadcrumbs
          .map((x, index, array) => {
            const breadcrumbBaseProps: BreadcrumbBaseProps = {
              type: containerType === "line" ? "text" : containerType,
              isHome: index === 0,
              children: x.title,
              current: index === (array.length - 1)
            };

            return (
              <Fragment key={`${x.href ?? x.to}_${index}`}>
                {
                  x.href
                    ? (
                      <BreadcrumbBase
                        {...breadcrumbBaseProps}
                        component={"a"}
                        href={x.href!}
                      />
                    )
                    : (
                      <BreadcrumbBase
                        {...breadcrumbBaseProps}
                        component={Link}
                        to={x.to!}
                      />
                    )
                }
                {
                  (index < (array.length - 1)) &&
                  <i className={styles.arrow}>
                    {dividerType === "chevron" ? <Chevron /> : <Slash />}
                  </i>
                }
              </Fragment>
            );
          })
      }
    </div>
  );
}));
